import {AccessorsMutatorsDecorator} from "../../helpers";
import {TranslatableModel} from "./translatable-model";
import {DefaultPropertyAmenity} from "./default-property-amenity.model";


export class Bank extends TranslatableModel {
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }
}

AccessorsMutatorsDecorator(
    'id', ...Bank.translatableAttributesWithLanguageAliases
)(Bank);


// WEBPACK FOOTER //
// ./src/pms-api/models/bank.model.js